var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"8","md":"12"}},[(_vm.$config.mandant == 'sak')?_c('sak-settings',{staticClass:"mb-4"}):_c('password-change',{staticClass:"mb-4"}),_c('customer-settings')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }